<template>
    <div class="footer-wrap">
        <div v-if="!homeName" class="fun-box flex flex-space-between">
            <div
                v-for="(item, i) in functionLists"
                :key="i"
                @click="handleFun(item, i)"
            >
                <img :src="require(`@/assets/imgs/icon${i + 1}.png`)" />
                <p>{{ item.name }}</p>
            </div>
        </div>
        <div class="tc footer-box">
            <!--  logo    -->
            <img src="@/assets/imgs/logo1.png" />
            <el-divider class="line-color"></el-divider>
            <p class="footer-a cursor-pointer flex flex-space-between">
                <label
                    v-for="(item, i) in menuLists"
                    :key="i"
                    class="cursor-pointer"
                    @click="handleRouter(item)"
                >{{ item.name }}</label
                >
            </p>
            <!-- 浏览量显示 -->
            <div class="pv-display">
                <div class="pv-number-box">
                    <div
                        v-for="(digit, index) in pvDigits"
                        :key="index"
                        class="pv-digit"
                    >{{ digit }}</div>
                </div>
            </div>
            <div class="footer-remark">
                <p> Copyright © 2025 scxbwg.cn 顺昌县博物馆  版权所有</p>
                <p> 闽ICP备2024034970号-2 </p>
            </div>
        </div>

        <!--   弹窗   -->

        <Dialog
            :dialogVisible.sync="dialogVisibleTip"
            :title="componentTitle"
            :showSubmitBtn="false"
        >
            <component :is="componentName"   @isFormSubmitFun='handleDialog' ></component>
        </Dialog>
    </div>
</template>

<script setup>
import { menuLists } from '@/util/const';
import { useRoute, useRouter } from 'vue-router/composables';
import { reactive, toRefs, computed, ref, onMounted } from 'vue';
import { addPV } from '@/api/index';
import Dialog from '@/components/dialog.vue';
import VisitReservation from '@/components/visitReservation.vue';
import NoticeVisitors from '@/components/noticeVisitors.vue';
import MapText from '@/components/mapText.vue';
import ContactUs from '@/components/contactUs.vue';
const router = useRouter();
const route = useRoute();

// 浏览量相关
const pvCount = ref(0);
const pvDigits = computed(() => {
    return String(pvCount.value).split('');
});

// 获取浏览量
const getPV = () => {
    addPV().then((res) => {
        if (res.code === 0 || res.repCode === '0000') {
            // 根据实际返回的数据结构调整
            pvCount.value = res.data?.pv || res.data?.total || res.data || 0;
        }
    }).catch((err) => {
        console.error('获取浏览量失败:', err);
    });
};

onMounted(() => {
    getPV();
});

const state = reactive({
    componentName: VisitReservation,
    componentTitle: '参观预约',
    dialogVisibleTip: false,
    functionLists: [
        {
            name: '参观预约',
            cName: VisitReservation
        },
        {
            name: '参观须知',
            cName: NoticeVisitors
        },
        {
            name: '交通地图',
            cName: MapText
        },
        {
            name: '联系我们',
            cName: ContactUs
        }
    // {
    //   name: "互动留言",
    //   cName: InteractiveMessage,
    // },
    ],
    isShowSubmitBtn: false,
    formData: false
});

const handleRouter = (item) => {
    router.push(item.path);
};

const handleFun = (item, i) => {
    state.componentTitle = state.functionLists[i].name;
    state.componentName = state.functionLists[i].cName;
    state.isShowSubmitBtn = item.name !== '互动留言';
    state.dialogVisibleTip = true;
};

const handleDialog = () => {
    state.dialogVisibleTip = false;
};

const homeName = computed(() => {
    return route.name === 'Home';
});


const { dialogVisibleTip, componentName, functionLists, componentTitle, isShowSubmitBtn, formData } = toRefs(state);
</script>

<style lang="scss" scoped>
.fun-box {
  padding: 80px 445px;
  box-sizing: border-box;
    background: url("~@/assets/imgs/bg2.png") no-repeat 100% 100%;
  > div {
      color:#262626;
    font-size: 23px;
    text-align: center;
    cursor: pointer;
    img {
      width: 76px;
      height: 76px;
      margin-bottom: 10px;
      //background: #772e22;
    }
  }
}
.footer-box {
  padding: 28px 0;
  color: #ffffff;
  background: rgba(0, 0, 0, 0.7);
  text-align: center;

  img {
      width: 238px;
      height: 54px;
    margin-bottom: 8px;
  }
  .footer-a {
    width: 600px;
    font-size: 20px;
    margin: 18px auto 47px;
  }
  .footer-remark {
    font-size: 16px;
  }
  .line-color {
    background-color: rgba(#f5f5f5,.2);
  }
  .pv-display {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px 0;
    font-size: 16px;
    .pv-label {
      margin-right: 12px;
      color: #ffffff;
    }
    .pv-number-box {
      display: flex;
      gap: 8px;
      .pv-digit {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 50px;
        background: #ffffff;
        color: #333333;
        font-size: 24px;
        font-weight: bold;
        border-radius: 4px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      }
    }
  }
}
.footer-wrap {
  //background: url("~@/assets/imgs/Group1166.png") no-repeat;
  background-size: 100% 100%;
}
</style>
